{
  "backButton": "Terug naar {prevMenuButton}",
  "moreActions": "Meer handelingen",
  "unavailable": "Niet beschikbaar, uitvouwen voor meer informatie"
}
